import { FC } from 'react';

export interface ItemLegenda {
  rotulo: string;
  cor: string;
  tracejado?: boolean;
}

/** Legenda em HTML acima do gráfico: amostra + nome, em texto de tema (nunca na cor da série). */
const Legenda: FC<{ itens: ItemLegenda[] }> = ({ itens }) => (
  <ul className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-content-secondary" aria-label="Legenda">
    {itens.map((i) => (
      <li key={i.rotulo} className="flex items-center gap-1.5">
        <span
          aria-hidden
          className="inline-block h-2.5 w-2.5 rounded-sm"
          style={
            i.tracejado
              ? { border: `1.5px dashed ${i.cor}`, background: 'transparent' }
              : { backgroundColor: i.cor }
          }
        />
        {i.rotulo}
      </li>
    ))}
  </ul>
);

export default Legenda;
